import request from '@/router/axios';

export const getUsualList = (current, size, query) => {
  return request({
    url: '/api/blade-log/usual/list',
    method: 'get',
    params: {
      ...query,
      current,
      size
    }
  })
}

export const getApiList = (current, size, query) => {
  return request({
    url: '/api/blade-log/api/list',
    method: 'get',
    params: {
      current,
      size,
      ...query
    }
  })
}

export const getErrorList = (current, size, query) => {
  return request({
    url: '/api/blade-log/error/list',
    method: 'get',
    params: {
      current,
      size,
      ...query
    }
  })
}


export const getUsualLogs = (id) => {
  return request({
    url: '/api/blade-log/usual/detail',
    method: 'get',
    params: {
      id,
    }
  })
}
export const getApiLogs = (id) => {
  return request({
    url: '/api/blade-log/api/detail',
    method: 'get',
    params: {
      id,
    }
  })
}
export const getErrorLogs = (id) => {
  return request({
    url: '/api/blade-log/error/detail',
    method: 'get',
    params: {
      id,
    }
  })
}

export const getUninterfaceLogList = (current, size, query) => {
  return request({
    url: '/api/interface-request-log/page',
    method: 'get',
    params: {
      current,
      size,
      ...query
    }
  })
}